import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, MoveRight } from "lucide-react";
import { kitchens } from "@/kitchens";

export function KitchenDetail() {
  const { slug } = useParams();
  const kitchen = kitchens.find((k) => k.slug === slug);
  const [variantImage, setVariantImage] = useState(null);

  if (!kitchen) {
    return (
      <section className="kitchen-detail" data-testid="kitchen-not-found">
        <Link to="/products" className="back-link" data-testid="back-to-collection-link">
          <ArrowLeft size={15} /> Back to the collection
        </Link>
        <h1 className="detail-missing">This kitchen is not in our collection.</h1>
      </section>
    );
  }

  return (
    <section className="kitchen-detail" data-testid="kitchen-detail-page">
      <Link to="/products" className="back-link" data-testid="back-to-collection-link">
        <ArrowLeft size={15} /> Back to the collection
      </Link>
      <div className="detail-grid">
        <figure className="detail-image" data-testid="kitchen-detail-image">
          <img src={variantImage || kitchen.image} alt={kitchen.alt} />
          <figcaption>{kitchen.index} / 07 — {kitchen.finish}</figcaption>
          {kitchen.variants && (
            <div className="finish-switcher" data-testid="finish-switcher">
              <span className="eyebrow">Preview finishes</span>
              <div className="swatches">
                <button type="button" className={`swatch${variantImage === null ? " active" : ""}`} onClick={() => setVariantImage(null)} data-testid="swatch-original"><i style={{ background: "#2b2f31" }} />Midnight</button>
                <button type="button" className={`swatch${variantImage === kitchen.variants.cream ? " active" : ""}`} onClick={() => setVariantImage(kitchen.variants.cream)} data-testid="swatch-cream"><i style={{ background: "#e8e0d2" }} />Cream</button>
                <button type="button" className={`swatch${variantImage === kitchen.variants.grey ? " active" : ""}`} onClick={() => setVariantImage(kitchen.variants.grey)} data-testid="swatch-grey"><i style={{ background: "#b9bcbe" }} />Grey</button>
              </div>
            </div>
          )}
        </figure>
        <div className="detail-specs">
          <span className="eyebrow">Kitchen {kitchen.index} / 07</span>
          <h1 data-testid="kitchen-detail-title">{kitchen.name}</h1>
          <p className="detail-description" data-testid="kitchen-detail-description">{kitchen.description}</p>
          <dl className="spec-list" data-testid="kitchen-spec-list">
            <div className="spec-row" data-testid="spec-finish">
              <dt>Finish</dt>
              <dd>{kitchen.finish}</dd>
            </div>
            <div className="spec-row" data-testid="spec-layout">
              <dt>Layout</dt>
              <dd>{kitchen.layout}</dd>
            </div>
            <div className="spec-row" data-testid="spec-materials">
              <dt>Materials</dt>
              <dd>
                <ul>
                  {kitchen.materials.map((m) => <li key={m}>{m}</li>)}
                </ul>
              </dd>
            </div>
          </dl>
          <Link to="/contact" className="button" data-testid="kitchen-consultation-cta">
            Book a private consultation <MoveRight size={17} />
          </Link>
        </div>
      </div>
    </section>
  );
}
